import {createSlice} from "@reduxjs/toolkit";
import {setPipelineInsightsFilter} from "./actions";
import {startOfDay, subDays} from "@ots-frontend/ots-data"

type PipelineInsightsState = {
  filter: {
    fromDttm: number,
    toDttm?: number
  }
}

const INITIAL_STATE: Readonly<PipelineInsightsState> = {
  filter: {
    fromDttm: subDays(startOfDay(new Date()), 1).getTime(),
  }
};

const pipelineInsightsSlice = createSlice({
  name: "ui/pipeline-insights",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setPipelineInsightsFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
  }
});

export const pipelineInsightsReducer = pipelineInsightsSlice.reducer;
